<template>
    <section class="nearby-neighborhoods">
        <header class="component-header container">
            <h2 class="headline-1">Nearby Neighborhood Areas</h2>
        </header>

        <ul class="list container">
            <li v-for="(item, key) in neighborhoods" class="neighborhood" :key="key">
                <NuxtLink :to="url + item?.id">
                    <figure>
                        <GlobalNeighborhoodMapImage :name="item?.fields?.Name || ''" loading="lazy" />
                        <div class="red-tag">
                            <span v-html="getSitesLength(item?.fields?.Sites)"></span>
                        </div>
                        <SvgsSiteTour />
                    </figure>
                    <h3 class="headline-3" v-html="item?.fields?.Name"></h3>
                </NuxtLink>
            </li>
        </ul>
    </section>
</template>

<script setup>
    import { neighborhoodSnakeCase } from '~/composables/helpers/neighborhoodSnakeCase.js';
    const { neighborhoods } = defineProps({
        neighborhoods: {
            type: Object,
            required: false,
            default: {},
        },
    });

    const getSitesLength = (itemSites) => {
        if (itemSites?.length == 1) return `${itemSites?.length} Site`;
        if (itemSites?.length > 1) return `${itemSites?.length} Sites`;
    };

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/neighborhoods/';
        else return '/neighborhoods/';
    });
</script>

<style lang="scss" scoped>
    .nearby-neighborhoods {
        padding-top: 30px;

        .list {
            display: flex;
            // Two cards per row, wrapping. Each card is calc(50% - 8px) and the
            // gap is 16px, so a full row still measures exactly 100% — the same
            // layout `justify-content: space-between` produced when there were
            // only ever two. 9 of the 27 neighborhoods list three or four nearby
            // areas, and without wrapping those ran to 150% of the container:
            // the page scrolled sideways to 737px inside a 529px viewport, which
            // is the cropping reported on mobile (Asana O2-39).
            flex-wrap: wrap;
            gap: 16px;
            margin-bottom: 20px;

            @media (min-width: $tablet) {
                margin-bottom: 60px;
            }

            .neighborhood {
                flex: 0 0 calc(50% - 8px);

                figure {
                    position: relative;
                    margin-bottom: 10px;
                    padding-top: 100%;

                    // :deep because the image is inside
                    // GlobalNeighborhoodMapImage now — a scoped `img` selector stops at
                    // the child's root <picture> and never reaches it.
                    img, :deep(img) {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .red-tag,
                    .site-tour {
                        position: absolute;
                        bottom: 15px;
                    }

                    .red-tag {
                        left: 15px;
                        padding: 10px 8px 6px;
                        background-color: $red;
                        color: $white;
                        font-size: 12px;
                        font-weight: 800;
                        text-align: center;
                    }

                    .site-tour {
                        right: 15px;
                    }
                }
            }
        }

        @media (min-width: $tablet) {
            .neighborhood figure {
                padding-top: 200px !important;
            }
        }
    }
</style>
